import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import * as actions from "../redux/actions";
import axios from "axios";
import _ from "lodash";
import {
  Table,
  Input,
  Button,
  Popconfirm,
  Form,
  Col,
  Row,
  Space,
  Tag,
  DatePicker,
  message,
  Select,
  Dropdown,
  Menu,
  Checkbox,
  Modal,
  Spin,
} from "antd";
import { PlusOutlined, CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { ReactComponent as FilterIcon } from "../../../assets/filter.svg";
import { ReactComponent as UploadEditIcon } from "../../../assets/upload-edit.svg";
import AMultiSelect from "../../../components/AMultiSelect";
import EditableCell from "./editableCell";
import StockRegisterCalender from "./stockRegisterCalender";
import CustomPagination from "../../../components/customPagination/CustomPagination";
import AttachmentContainer from "./AttachmentContainter";
import moment from "moment";
import ExpandedRow from "./expandedRow/expandedRow";
import FilterSection from "./filterSection";
import { LabsStockProvider, useLabsStock } from "../context/LabsStockContext";

const DistributionTableContent = ({ notificationAction: propsAction, clearExpansionParams: propsClear, isFromNotification }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  
  // Get values from URL if props are missing
  const notificationAction = propsAction || {
    action: { expandSection: searchParams.get('section') },
    linkedId: searchParams.get('expand')
  };

  const clearExpansionParams = propsClear || (() => {
    searchParams.delete('section');
    searchParams.delete('expand');
    setSearchParams(searchParams);
  });
  const dispatch = useDispatch();
  const {
    handleCompleteStockTake,
    isAmending,
    setIsAmending,
    stockTakeDataMap,
    updateStockTakeData,
    setStockTakeDataMap,
    expandedRowKeys,
    setExpandedRowKeys,
    images,
    setImages,
    attachPopupVisible,
    setAttachPopupVisible,
    fields,
    setFields,
    currentUpdateObj,
    getColumnName,
    labSetupId,
    createStockManagementRegister,
    deleteStockManagementRegister,
    finalizeRegister,
    deletableRegisters,
    setDeletableRegisters,
    generateUniqueId,
    labName,
    getWarehouseName,
    finalizedStockTakes,
    canExport,
  } = useLabsStock();

  const { lab_id } = useParams();
  const [data, setData] = useState([]);
  const [newlyAddedRecords, setNewlyAddedRecords] = useState(new Set());
  
  const [dateRange, setDateRange] = useState([null, null]);
  const [datePickerOpened, setDatePickerOpened] = useState(false);
  const [statusCheckedList, setStatusCheckedList] = useState([]);
  const [salesRepCheckedList, setSalesRepCheckedList] = useState([]);
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [req, setReq] = useState(false);
  const [defaultPageOneReq, setDefaultPageOneReq] = useState(false);
  const [sortedInfo, setSortedInfo] = useState(null);
  const [search, setSearch] = useState({});
  const statusFilterOptions = [
    { value: "Incomplete", label: "Incomplete" },
    { value: "Completed", label: "Completed" },
  ];
  const [page, setPage] = useState(1);
  const [resultPerPage, setResultPerPage] = useState(10);
  const [showFilter, setShowFilter] = useState(false);
  const [filter, setFilter] = useState({});
  const [filterDataFetched, setFilterDataFetched] = useState(false);
  const [exportModalVisible, setExportModalVisible] = useState(false);
  const [exportRecordId, setExportRecordId] = useState(null);
  const [isExported, setIsExported] = useState(false);
  const [isExporting, setIsExporting] = useState(false);

  const { user } = useSelector((state) => state.authReducer);
  const allstockManagementRegisters = useSelector((state) => state.labsStockManagementReducer.allstockManagementRegisters);
  const fetchingLoading = useSelector((state) => state.labsStockManagementReducer.fetchingLoading);
  const totalRecords = useSelector((state) => state.labsStockManagementReducer.totalRecords);
  const newStockManagementRegister = useSelector((state) => state.labsStockManagementReducer.newStockManagementRegister);
  
  useEffect(() => {
    if (notificationAction && 
        allstockManagementRegisters && 
        allstockManagementRegisters.length > 0) {
      
      let targetRegister = null;
      
      if (notificationAction.action?.expandSection === 'variance-reports' && notificationAction.linkedId) {
        const targetId = Number(notificationAction.linkedId);
        targetRegister = allstockManagementRegisters.find(record => record.id === targetId);
      } else if (notificationAction.action?.expandSection === 'stock-management' && notificationAction.linkedId === 'first') {
        targetRegister = allstockManagementRegisters[0];
      }
      
      if (targetRegister) {
        setExpandedRowKeys([targetRegister.id]);
        
        setTimeout(() => {
          const element = document.querySelector(`[data-row-key="${targetRegister.id}"]`);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }, 300);
        
        if (clearExpansionParams) {
          setTimeout(() => {
            clearExpansionParams();
          }, 500);
        }
      }
    }
  }, [notificationAction, allstockManagementRegisters, setExpandedRowKeys, clearExpansionParams, labSetupId]);

  const salesRepFilterOptions = useMemo(() => {
    if (!allstockManagementRegisters || allstockManagementRegisters.length === 0) {
      return [];
    }
    const uniqueSalesReps = {};
    allstockManagementRegisters.forEach(register => {
      if (register?.user?.id && register?.user?.firstName) {
        const key = register.user.id;
        if (!uniqueSalesReps[key]) {
          uniqueSalesReps[key] = {
            value: register.user.id,
            label: `${register.user.firstName} ${register.user.lastName || ""}`.trim()
          };
        }
      }
    });
    return Object.values(uniqueSalesReps);
  }, [allstockManagementRegisters]);
  const prevLabSetupId = useRef(labSetupId);

  useEffect(() => {
    if (!labSetupId) return;

    const isLabChanged = prevLabSetupId.current !== labSetupId;

    if (isLabChanged) {
      setFilter({});
      setFilterDataFetched(false);
      setPage(1);
      prevLabSetupId.current = labSetupId;
    }

    const params = {
      ...search,
      ...(isLabChanged ? {} : filter),
      page: (isLabChanged ? 1 : page) || 1,
      perPage: resultPerPage || 10,
      labSetupId,
    };

    if (sortedInfo?.columnKey && sortedInfo?.order) {
      if (sortedInfo.columnKey !== "salesRep") {
        const sortColumn =
          sortedInfo.columnKey === "statusName"
            ? "status"
            : sortedInfo.columnKey;
        params.sortBy = sortColumn;
        params.sortOrder = sortedInfo.order === "ascend" ? "asc" : "desc";
      }
    }

    dispatch(actions.fetchAllStockManagementRegisters(params));
  }, [req, page, defaultPageOneReq, resultPerPage, labSetupId]);

  useEffect(() => {
    if (allstockManagementRegisters && allstockManagementRegisters.length > 0) {
      const newStockTakeDataMap = {};

      const formattedData = allstockManagementRegisters.map((register) => {
        const stockTakeCount = register.stockTakes?.length || 0;
        const omniQty = register.omniQty || 0;
        const stockQty = stockTakeCount;
        const rawVarianceQty = register.varianceQty !== undefined && register.varianceQty !== null ? register.varianceQty : (omniQty - stockQty);
        const varianceQty = Math.abs(rawVarianceQty);

        const salesRepName = register.user
          ? `${register.user.firstName || ""} ${register.user.lastName || ""}`.trim()
          : "";

        if (register.stockTakes && register.stockTakes.length > 0) {
          newStockTakeDataMap[register.id] = register.stockTakes.map(stockTake => ({
            id: stockTake.id,
            key: stockTake.id,
            scannedCode: stockTake.scannedCode || "",
            lotNo: stockTake.lotNo || "",
            expiryDate: stockTake.expiryDate ? moment(stockTake.expiryDate).format("YYYY-MM-DD") : "",
            daysPastExpiry: stockTake.daysPastExpirey || stockTake.daysPastExpiry || 0,
            barCode: stockTake.barcode || "",
            stockItemLookup: stockTake.stockItemLookup || "",
            level: stockTake.level || "",
          }));
        } else {
          newStockTakeDataMap[register.id] = [];
        }

        return {
          id: register.id,
          key: register.id,
          date: register.date ? moment(register.date).format("DD MMM YYYY") : "",
          uniqueId: register.uniqueId || "",
          salesRep: salesRepName,
          omniQty: omniQty,
          stockQty: stockQty,
          varianceQty: varianceQty,
          statusName: register.status || "Incomplete",
          statusColor: register.statusColor || "#fcb9b8",
          attach: register.attachments || [],
          varianceReports: register.varianceReports || register.variance_reports || [],
          rawData: register,
        };
      });

      setStockTakeDataMap(newStockTakeDataMap);
      setData(prev => {
        const pending = prev.filter(r => r.isPendingCreation);
        const nonDuplicateFormatted = formattedData.filter(r => !pending.some(p => String(p.id) === String(r.id)));
        return [...pending, ...nonDuplicateFormatted];
      });
    } else if (allstockManagementRegisters && allstockManagementRegisters.length === 0) {
      setData([]);
      setStockTakeDataMap({});
    }
  }, [allstockManagementRegisters]);

  useEffect(() => {
    if (newStockManagementRegister && newStockManagementRegister.id) {
      const tempRecord = data.find(r => r.isPendingCreation);

      if (tempRecord) {
        const incompleteStatus = { statusName: "Incomplete", color: "#fcb9b8" };

        const newRecord = {
          id: newStockManagementRegister.id,
          key: newStockManagementRegister.id,
          date: newStockManagementRegister.date ? moment(newStockManagementRegister.date).format("DD MMM YYYY") : moment().format("DD MMM YYYY"),
          uniqueId: newStockManagementRegister.uniqueId || "",
          salesRep: newStockManagementRegister.salesRep || tempRecord.salesRep,
          omniQty: newStockManagementRegister.omniQty || 0,
          stockQty: 0,
          varianceQty: 0,
          labStatus: newStockManagementRegister.labStatus || incompleteStatus,
          statusName: newStockManagementRegister.status || "Incomplete",
          attach: newStockManagementRegister.attachments || [],
          isNew: true,
          rawData: newStockManagementRegister,
        };

        setData(prev => {
          const filtered = prev.filter(r => !r.isPendingCreation && String(r.id) !== String(newStockManagementRegister.id));
          return [newRecord, ...filtered];
        });

        setExpandedRowKeys([newStockManagementRegister.id]);

        setDeletableRegisters(prev => {
          const newState = { ...prev };
          delete newState[tempRecord.id];
          // Add the real ID
          newState[newStockManagementRegister.id] = { canDelete: true, isExpanded: true };
          return newState;
        });
      }
    }
  }, [newStockManagementRegister]);

  const handleExportRegister = async (recordId) => {
    if (!recordId) return false;

    const record = data.find(r => r.id === recordId);
    const uniqueId = record?.uniqueId || 'unknown';
    const fileName = `stock-register-${uniqueId}.xlsx`;

    try {
      const response = await axios.get(
        `/stock-management-register/${recordId}/export`,
        { responseType: "blob" }
      );

      if (window.showSaveFilePicker) {
        try {
          const handle = await window.showSaveFilePicker({
            suggestedName: fileName,
            types: [{
              description: 'Excel Files',
              accept: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }
            }]
          });
          const writable = await handle.createWritable();
          await writable.write(response.data);
          await writable.close();
          return true;
        } catch (pickerError) {
          if (pickerError.name === 'AbortError') {
            return false;
          }
          throw pickerError;
        }
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return true;
      }
    } catch (error) {
      message.error("Failed to export register");
      return false;
    }
  };

  const handleExportClick = (recordId) => {
    if (!recordId) return;
    setExportRecordId(recordId);
    setExportModalVisible(true);
    setIsExported(false);
    setIsExporting(false);
  };

  const handleExportConfirm = async () => {
    if (!exportRecordId || isExporting || !canExport) return;

    setIsExporting(true);
    const success = await handleExportRegister(exportRecordId);
    setIsExporting(false);

    if (success) {
      setIsExported(true);
    }
  };

  const handleExportCancel = () => {
    setExportModalVisible(false);
    setExportRecordId(null);
    setIsExported(false);
    setIsExporting(false);
  };

  const [debouncedCallApi] = useState(() =>
    _.debounce(() => setReq((prev) => !prev), 1000)
  );

  const [debouncedDefaultPageOneCallApi] = useState(() =>
    _.debounce(() => setDefaultPageOneReq((prev) => !prev), 1000)
  );

  const onCloseFilter = () => {
    setShowFilter(false);
    setFilter({});
    setFilterDataFetched(false);
    debouncedDefaultPageOneCallApi();
  };

  const handleFilter = (filterObj) => {
    setFilter(filterObj);
    setFilterDataFetched(true);
    debouncedDefaultPageOneCallApi();
  };

  const isEditing = (record) => {
    // Check if this record is currently being edited
    // If we're in loading state for this record, we still want to show the form fields
    // but disable editing
    return record.key === editingKey || record.id === editingKey;
  };

  const handleColOnClick = (record) => {
    if (expandedRowKeys.includes(record.id)) {
      const deletableInfo = deletableRegisters[record.id];
      if (deletableInfo?.canDelete) {
        finalizeRegister(record.id);
      }
      setExpandedRowKeys([]);
    } else {
      setExpandedRowKeys([record.id]);
    }
  };

  const [areaOptions, setAreaOptions] = useState([]);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [areaDropdownVisible, setAreaDropdownVisible] = useState(false);

  const handleDateInput = (dates) => {
    setDateRange(dates);
    const dateStrings = dates ? [dates[0]?.format('YYYY-MM-DD'), dates[1]?.format('YYYY-MM-DD')] : ['', ''];
    setSearch({
      ...search,
      startDate: dateStrings[0] || '',
      endDate: dateStrings[1] || '',
    });
    debouncedDefaultPageOneCallApi();
  };

  const searchInput = (key) => {
    if (key === 'date') {
      return (
        <StockRegisterCalender
          date={dateRange}
          format="DD MMM YY"
          handleDateInput={handleDateInput}
          setDate={setDateRange}
          setDatePickerOpened={setDatePickerOpened}
        />
      );
    }
    if (key === "area") {
      return (
        <Dropdown
          // overlay={areaDropdownContent}
          trigger={['click']}
          visible={areaDropdownVisible}
          onVisibleChange={(visible) => {
            // Only update if the dropdown is being opened or closed by clicking outside
            // This prevents the dropdown from closing when clicking inside it
            if (!visible || !areaDropdownVisible) {
              setAreaDropdownVisible(visible);
            }
          }}
          placement="bottomLeft"
          overlayStyle={{ minWidth: '350px' }}
        >
          <Input
            placeholder={""}
            value={selectedAreas.length > 0 ? selectedAreas.length : ""}
            readOnly
            className="area-dropdown-trigger"
            onClick={(e) => e.stopPropagation()}
          />
        </Dropdown>
      );
    }
    return (
      <Input
        placeholder={""}
        onClick={(e) => e.stopPropagation()}
        value={search[key] || ""}
        onChange={(e) => {
          setSearch({
            ...search,
            [key]: e.target.value,
          });
          debouncedDefaultPageOneCallApi();
        }}
      />
    );
  };

  const handleMultiSelect = (list, key) => {
    setSearch({
      ...search,
      [key]: list,
    });
    // debouncedDefaultPageOneCallApi();
  };

  const handleSelectOnchange = (value, options, key, setHandler) => {
    if (value.includes("all")) {
      setHandler([...options.map((item) => item.value)]);
      value = options.map((item) => item.value);
    } else if (value.includes("not-all")) {
      setHandler([]);
      value = [];
    } else {
      setHandler(value);
    }
    handleMultiSelect(value, key);
    debouncedCallApi();
  };

  const handleAdd = () => {
    const currentDate = moment().format("DD MMM YYYY");
    const salesRepName = user ? `${user.firstName || ""} ${user.lastName || ""}`.trim() : "System User";
    const warehouseName = getWarehouseName(labName);
    const newUniqueId = generateUniqueId(labSetupId, warehouseName);

    const registerData = {
      date: new Date().toISOString(),
      uniqueId: newUniqueId,
      salesRep: salesRepName,
      omniQty: 0,
      stockQty: 0,
      varianceQty: 0,
      userId: user?.id || 1,
      labSetupId: labSetupId || 1
    };

    createStockManagementRegister(registerData);

    const tempId = `temp_${Date.now()}`;
    const newRecord = {
      id: tempId,
      key: tempId,
      date: currentDate,
      uniqueId: newUniqueId,
      salesRep: salesRepName,
      omniQty: 0,
      stockQty: 0,
      varianceQty: 0,
      statusName: "Incomplete",
      statusColor: "#fcb9b8",
      attach: 0,
      isNew: true,
      isPendingCreation: true,
    };

    setData([newRecord, ...data]);
    setNewlyAddedRecords(prev => new Set(prev).add(tempId));
    setExpandedRowKeys([tempId]);
    setDeletableRegisters(prev => ({
      ...prev,
      [tempId]: { canDelete: true, isExpanded: true }
    }));
  };

  const handleCancel = (recordId) => {
    const record = data.find(r => r.id === recordId);

    if (record?.isPendingCreation) {
      setData(prev => prev.filter(r => String(r.id) !== String(recordId)));
      setNewlyAddedRecords(prev => {
        const newSet = new Set(prev);
        newSet.delete(recordId);
        return newSet;
      });
      setExpandedRowKeys(prev => prev.filter(key => key !== recordId));
      setDeletableRegisters(prev => {
        const newState = { ...prev };
        delete newState[recordId];
        return newState;
      });
      return;
    }

    if (record?.id && !record.isPendingCreation) {
      deleteStockManagementRegister(record.id);
    }

    setData(prev => prev.filter(record => String(record.id) !== String(recordId)));
    setNewlyAddedRecords(prev => {
      const newSet = new Set(prev);
      newSet.delete(recordId);
      return newSet;
    });
    setExpandedRowKeys(prev => prev.filter(key => key !== recordId));
  };

  const columns = useMemo(() => [
    {
      title: () => {
        return (
          <div align="left" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(0)}</div>
            <div>{searchInput("date")}</div>
          </div>
        );
      },
      dataIndex: "date",
      key: "date",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "date" && sortedInfo?.order,
      width: 100,
      editable: true,
      render: (date, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>
            {record?.date}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(1)}</div>
            <div>{searchInput("uniqueId")}</div>
          </div>
        );
      },
      dataIndex: "uniqueId",
      key: "uniqueId",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "uniqueId" && sortedInfo?.order,
      width: 100,
      editable: true,
      render: (uniqueId, record) => {
        return (
          <div onClick={() => handleColOnClick(record)}>
            {record?.uniqueId}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">{getColumnName(2)}</div>
            <div style={{ width: "100%" }}>
              <AMultiSelect
                dropdownClassName="salesRep-selector"
                debouncedCallApi={debouncedCallApi}
                disabled={false}
                placeholder=""
                selectTags={salesRepCheckedList}
                onSelectChange={(value) =>
                  handleSelectOnchange(
                    value,
                    salesRepFilterOptions,
                    "userIds",
                    setSalesRepCheckedList
                  )
                }
                data={salesRepFilterOptions}
                filterOption={(input, option) => {
                  return (
                    String(option?.label)
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              />
            </div>
          </div>
        );
      },
      dataIndex: "salesRep",
      key: "salesRep",
      sorter: (a, b) => {
        const nameA = (a.salesRep || "").toLowerCase();
        const nameB = (b.salesRep || "").toLowerCase();
        return nameA.localeCompare(nameB);
      },
      sortOrder: sortedInfo?.columnKey === "salesRep" && sortedInfo?.order,
      width: 150,
      editable: true,
      render: (salesRep, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.salesRep}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(3)}</div>
            <div>{searchInput("omniQty")}</div>
          </div>
        );
      },
      dataIndex: "omniQty",
      key: "omniQty",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "omniQty" && sortedInfo?.order,
      width: 70,
      align: "center",
      editable: true,
      render: (omniQty, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.omniQty}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(4)}</div>
            <div>{searchInput("stockQty")}</div>
          </div>
        );
      },
      dataIndex: "stockQty",
      key: "stockQty",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "stockQty" && sortedInfo?.order,
      width: 80,
      align: "center",
      editable: true,
      render: (stockQty, record) => (
        <div onClick={() => handleColOnClick(record)}>
          {record?.stockQty}
        </div>
      ),
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(5)}</div>
            <div>{searchInput("varianceQty")}</div>
          </div>
        );
      },
      dataIndex: "varianceQty",
      key: "varianceQty",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "varianceQty" && sortedInfo?.order,
      width: 95,
      align: "center",
      editable: true,
      render: (varianceQty, record) => {
        const val = record?.varianceQty;
        return (
          <div onClick={() => handleColOnClick(record)}>
            {val !== 0 ? (
              <span
                style={{
                  display: "inline-block",
                  width: "34px",
                  height: "20px",
                  backgroundColor: "#e20f00",
                  color: "white",
                  borderRadius: "3px",
                  textAlign: "center",
                  lineHeight: "18px",
                  fontSize: "11px",
                  fontWeight: 500,
                }}
              >
                {val}
              </span>
            ) : (
              val
            )}
          </div>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" style={{ width: "100%" }}>
            <div className="special-table-header-text">{getColumnName(6)}</div>
            <div style={{ width: "100%" }}>
              <AMultiSelect
                dropdownClassName="status-selector"
                debouncedCallApi={debouncedCallApi}
                disabled={false}
                placeholder=""
                selectTags={statusCheckedList}
                onSelectChange={(value) =>
                  handleSelectOnchange(
                    value,
                    statusFilterOptions,
                    "status",
                    setStatusCheckedList
                  )
                }
                data={statusFilterOptions}
                filterOption={(input, option) => {
                  return (
                    String(option?.label)
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
              />
            </div>
          </div>
        );
      },
      dataIndex: "statusName",
      key: "statusName",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "statusName" && sortedInfo?.order,
      ellipsis: true,
      width: 100,
      align: "center",
      render: (statusName, record) => {
        let tagColor = record.statusColor || "#fcb9b8";
        let displayStatus = statusName;

        if (statusName?.toLowerCase() === "completed") {
          tagColor = "#a7e0a5";
          displayStatus = "Completed";
        } else if (statusName?.toLowerCase() === "incomplete") {
          tagColor = "#fcb9b8";
          displayStatus = "Incomplete";
        }

        return (
          <Tag
            color={tagColor}
            style={{
              color: "#383838",
              width: "90px",
              height: "20px",
              borderRadius: "10px",
              textAlign: "center",
              fontSize: "12px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              border: 'none',
              cursor: 'pointer'
            }}
          >
            {displayStatus}
          </Tag>
        );
      },
    },
    {
      title: () => {
        return (
          <div align="top" className="select-parent-div">
            <div className="special-table-header-text">{getColumnName(7)}</div>
            <div>{searchInput("attach")}</div>
          </div>
        );
      },
      dataIndex: "attach",
      key: "attach",
      sorter: true,
      sortOrder: sortedInfo?.columnKey === "attach" && sortedInfo?.order,
      width: 50,
      editable: true,
      render: (attach, record) => {
        const isExpanded = expandedRowKeys.includes(record.id);
        return (
          <AttachmentContainer
            recordType="labs_stock_management"
            record={record}
            color="#ed017f"
            disabled={isAmending}
            isExpanded={isExpanded}
          />
        );
      },
    },
    {
      title: "",
      key: "actions",
      width: 100,
      align: "center",
      render: (_, record) => {
        const deletableInfo = deletableRegisters[record.id];
        const isExpanded = expandedRowKeys.includes(record.id);
        const stockTakes = stockTakeDataMap[record.id] || [];
        const hasStockTakes = stockTakes.length > 0;
        const isNewlyCreated = newlyAddedRecords.has(record.id);

        const canDelete = deletableInfo?.canDelete && isExpanded && !hasStockTakes;
        const isFinalized = !!finalizedStockTakes[record.id];
        
        const hasVarianceReports = 
          (record.varianceReports && record.varianceReports.length > 0);

        const iconColor = isExpanded ? '#ffffff' : '#ed017f';

        const exportButtonStyle = {
          color: iconColor,
          border: 'none',
          background: 'transparent',
          padding: '4px',
          height: 'auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
        };

        if (canDelete || isNewlyCreated) {
          return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              {isExpanded && hasVarianceReports && canExport && (
                <UploadEditIcon
                  className="custom-icon"
                  style={{ 
                    width: '18px', 
                    height: '18px', 
                    color: iconColor, 
                    fill: iconColor,
                    ...exportButtonStyle
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleExportClick(record.id);
                  }}
                  title="Export register"
                />
              )}
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCancel(record.id);
                }}
                style={{
                  color: '#ff4d4f',
                  border: 'none',
                  background: 'transparent',
                  padding: '4px 8px',
                  height: 'auto',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                title={canDelete ? "Delete register" : "Cancel record creation"}
              />
            </div>
          );
        }
        return hasVarianceReports && canExport ? (
          <Button
            type="text"
            icon={
              <UploadEditIcon
                className="custom-icon"
                style={{ width: '18px', height: '18px', color: iconColor, fill: iconColor }}
              />
            }
            onClick={(e) => {
              e.stopPropagation();
              handleExportClick(record.id);
            }}
            style={exportButtonStyle}
            title="Export register"
          />
        ) : null;
      },
    },
  ], [search, dateRange, statusCheckedList, salesRepCheckedList, sortedInfo, newlyAddedRecords, getColumnName, debouncedCallApi, handleSelectOnchange, salesRepFilterOptions, finalizedStockTakes, canExport]);

  const mainColumns = useMemo(() => {
    return columns.map((col) => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: (record) => {
          return {
            record,
            // inputType:,
            dataIndex: col.dataIndex,
            title: col.title,
            editing: isEditing(record),
          };
        },
      };
    });
  }, [columns, editingKey]);

  const handleChange = (pagination, filters, sorter) => {
    setSortedInfo(sorter);
    if (pagination.current && pagination.current !== page) {
      setPage(pagination.current);
    }
    if (pagination.pageSize && pagination.pageSize !== resultPerPage) {
      setResultPerPage(pagination.pageSize);
    }
    debouncedCallApi();
  };

  const components = useMemo(() => ({
    body: {
      cell: (props) => (
        <EditableCell
          cell={props}
        />
      ),
    },
  }), []);

  const expandedRowRender = useCallback((record) => {
    return <ExpandedRow record={record} />;
  }, []);

  const expandableConfig = useMemo(() => ({
    expandedRowRender,
    expandIcon: null,
    showExpandColumn: false,
    expandedRowKeys: expandedRowKeys,
    rowExpandable: ({ id }) => expandedRowKeys.includes(id),
  }), [expandedRowRender, expandedRowKeys]);

  return (
    <Row className="doc-control-parent-row">
      <Col span={24} className="heading-col">
        <Row align="middle" gutter={[50, 0]} justify="space-between">
          <Col>
            <Row gutter={[50, 0]} align="middle">
              <Col>
                <div>
                  <span className="heading-span" style={{ color: "#000" }}>
                    STOCK MANAGEMENT REGISTER
                  </span>
                </div>
              </Col>
              <Col>
                <Button
                  icon={<PlusOutlined />}
                  className="add-doc-btn"
                  size="middle"
                  onClick={handleAdd}
                  disabled={expandedRowKeys.length > 0}
                >
                  ADD
                </Button>
              </Col>
            </Row>
          </Col>
          <Col>
            <FilterIcon
              className="pink-icon"
              onClick={() => setShowFilter(!showFilter)}
              style={{ cursor: 'pointer', width: '24px', height: '24px', color: '#ed017f' }}
            />
          </Col>
        </Row>
      </Col>
      {showFilter && (
        <FilterSection
          handleClose={onCloseFilter}
          handleFilter={handleFilter}
          setFilterDataFetched={setFilterDataFetched}
        />
      )}
      <Col span={24}>
        <Form form={form} component={false} >
          <Table
            scroll={{ x: 'max-content' }}
            className={`special-table ims-doc-table `}
            components={components}
            expandable={expandableConfig}
            onRow={({ id }) =>
              expandedRowKeys.includes(id) && {
                className: `expand-doc-parent`,
              }
            }
            rowKey={(record) => record.id}
            rowClassName="editable-row"
            dataSource={data}
            columns={mainColumns}
            onChange={handleChange}
            loading={fetchingLoading}
            pagination={false}
          />
          <CustomPagination
            page={page}
            setPage={setPage}
            resultPerPage={resultPerPage}
            setResultPerPage={setResultPerPage}
            totalRecord={totalRecords}
            debouncedCallApi={debouncedCallApi}
          />
        </Form>
        <Modal
          title="EXPORT"
          open={exportModalVisible}
          onCancel={handleExportCancel}
          footer={null}
          width={350}
        >
          <div style={{ padding: '20px 0', textAlign: 'center' }}>
            <p style={{ margin: 0, fontSize: '16px', color: '#333', fontFamily: 'poppins, Arial' }}>
              {isExported
                ? "Document Exported Successfully."
                : `Export Stock Take ID ${data.find(r => r.id === exportRecordId)?.uniqueId || 'N/A'}`}
            </p>
          </div>
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            {isExporting ? (
              <Spin indicator={<LoadingOutlined style={{ fontSize: 24, color: '#ed017f' }} spin />} />
            ) : (
              <Button
                type="primary"
                icon={!isExported ? (
                  <UploadEditIcon
                    className="white-icon"
                    style={{ width: '16px', height: '16px', color: '#ffffff', fill: '#ffffff' }}
                  />
                ) : undefined}
                className="add-doc-btn"
                onClick={isExported ? handleExportCancel : handleExportConfirm}
                disabled={isExporting || (!isExported && !canExport)}
                style={{
                  background: '#ed017f',
                  borderColor: '#ed017f',
                  borderRadius: '2px',
                  color: '#ffffff',
                  fontFamily: 'poppins, Arial',
                  padding: '8px 24px',
                  height: 'auto',
                  display: canExport || isExported ? 'inline-flex' : 'none',
                  alignItems: 'center',
                  gap: '8px'
                }}
              >
                {isExported ? "Close" : "Export File"}
              </Button>
            )}
          </div>
        </Modal>
      </Col>
    </Row>
  )
}

const DistributionTable = () => {
  return (
    <LabsStockProvider>
      <DistributionTableContent />
    </LabsStockProvider>
  );
};

export default DistributionTable;